import type { ITreeItem } from '@components/tree/VTree/types';
import { YML_INDENT } from '@modules/translate-manager/constants';

export default function convertTreeListToYmlSyntax(items: ITreeItem[], output = '', indent = ''): string {
  let result = output;
  let treePart = '';

  for (const item of items) {
    treePart += `${indent}${item.label}:\n`;

    if (item.children) {
      treePart = convertTreeListToYmlSyntax(item.children as ITreeItem[], treePart, indent ? `${indent}${YML_INDENT}` : YML_INDENT);
    }
  }

  result += treePart;

  return result;
}
